import { render } from "./Onboard2.vue?vue&type=template&id=48e0ac79"
import script from "./Onboard2.vue?vue&type=script&lang=js"
export * from "./Onboard2.vue?vue&type=script&lang=js"

import "./Onboard2.vue?vue&type=style&index=0&id=48e0ac79&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__